module.exports = __webpack_public_path__ + "static/media/pattern-bg.bb83e5bd.svg";